import { render, staticRenderFns } from "./FontAlign.vue?vue&type=template&id=7f95dcf3&scoped=true&"
import script from "./FontAlign.vue?vue&type=script&lang=ts&"
export * from "./FontAlign.vue?vue&type=script&lang=ts&"
import style0 from "./FontAlign.vue?vue&type=style&index=0&id=7f95dcf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f95dcf3",
  null
  
)

export default component.exports